<template>
  <AppButton
    v-bind="$attrs"
    variant="secondary"
    class="w-[200px] justify-center whitespace-nowrap px-4 py-2 text-[1.1rem]"
    @click="$emit('click', $event)"
  >
    <span>{{ $t('Expand map') }}</span>
    <img src="@/assets/images/maps.svg" alt="" class="w-[1.6rem] h-[1.6rem]" />
  </AppButton>
</template>

<script>
import AppButton from '@/components/buttons/AppButton.vue';

export default {
  name: 'MapExpandButton',
  components: {
    AppButton,
  },
  inheritAttrs: false,
  emits: ['click'],
};
</script>
